import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import SignUp from './SignUp';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Cookies from 'js-cookie';


export default function BeginnerSignUp() {

    const [activeStep, setActiveStep] = React.useState(1);
    const steps = ['회원가입', '자리선택', '잔액충전', '자리이용'];

    const loginComplete = () => {
        setActiveStep(1);
    }

    const renderTutorial = () => {
        switch (activeStep) {
            case 0:
                return <SignUp loginComplete={loginComplete} />;
            case 1:
            case 2:
                const loginId = Cookies.get("LoginId");
                return (
                    <div>
                        <p>{loginId}님 가입이 완료되었습니다.</p>
                        
                        <p>현재 내 잔액 : 0원</p>

                        <p>잔액 충천 시 아래와 같은 혜택이 있습니다. 최대한 활용하셔서 저렴하게 이용하세요!</p>
                        
                        <p>1. 10,000원 이상 충전시 충전금액의 2% 추가 충전</p>
                        <p>2. 잔액이 10,000원 이상 남아있을 경우 매일 100포인트 지급</p>

                        <p>※ 사용하고 남은 잔액은 기한제한없이 언제든지 다시 사용하실 수 있습니다.</p>
                        <p>※ 포인트는 자리이용, 음료구입, 사물함 등 카페 내 모든 곳에서 사용할 수 있습니다.</p>
                        
                        

                        <p>원하시는 충전 방법을 선택해주세요.</p>
                        <Button variant="contained" color="primary">
                            카드
                        </Button>
                        <Button variant="contained" color="primary">
                            현금
                        </Button>
                        <p>아래에서 이용을 원하시는 자리를 선택해주세요!</p>
                    </div>
                );6
        }
    }

    return (
        <div>
            <h2>“편안하고 아늑한 나만의 공간. 슷Cafe를 방문해주셔서 감사합니다!”</h2>
            <h5>이 테블릿으로 자리이용, 음료구입, 사물함이용 모두 하실 수 있습니다.</h5>
            <h5>아래 순서대로 카페 이용방법을 안내해드리겠습니다.</h5>

            <Stepper activeStep={activeStep} alternativeLabel>
                {steps.map(label => (
                    <Step key={label}>
                        <StepLabel><h6>{label}</h6></StepLabel>
                    </Step>
                ))}
            </Stepper>
            {renderTutorial()}
        </div>
    );
    
}



// WEBPACK FOOTER //
// ./src/components/BeginnerSignUp.js